import { createContext, useContext } from 'react'

import { useFetchManagedEventTypesQuery, selectManagedEventTypeById } from './api'
import { useManagedEventTypeQueryParams } from './use_managed_event_type_query_params'

const ManagedEventTypeContext = createContext({})

export const { Provider: ManagedEventTypeContextProvider } = ManagedEventTypeContext

export const useManagedEventTypeContext = () => {
  const { id } = useContext(ManagedEventTypeContext)
  const [queryParams] = useManagedEventTypeQueryParams()
  const { data } = useFetchManagedEventTypesQuery({ ...queryParams })

  return selectManagedEventTypeById(data.collection, id)
}
